import React, { useState, useEffect } from "react";
import { TextField, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "antd";
import { loginAdmin } from "../redux/admin/adminSlice";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.admin);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [visible, setVisible] = useState(false);
  const [buttonPressed, setButtonPressed] = useState(false);

  // useEffect(() => {
  //   if (admin) {
  //     navigate("/admin");
  //   }
  // }, [admin, navigate]);

  useEffect(() => { 
    if (buttonPressed) {
      setEmailError(email ? "" : "Required");
      setPasswordError(password ? "" : "Required");
    }
  }, [buttonPressed, email, password]);

  const handleClickShowPassword = () => setVisible(!visible);

  const handleLogin = async (e) => {
    e.preventDefault();
    dispatch(loginAdmin({ email, password }))
      .unwrap()
      .then(() => {
        navigate("/admin");
      })
      .catch((err) => alert(err));
  };

  return (
    <div className="maincontainer_log">
      <div className="imagecontainer">
        <img src="./assets/img/hero/navratri.jpg" alt="Login Banner" />
      </div>
      <div className="loginbox">
        <div className="login_div_cont">
          <div className="log_main">
            <span className="login_tobler_name">
              {/* <img src="/assets/img/logo/f1visalogo8.svg" alt="Logo" /> */}
            </span>

            <div className="margin_top">
              <TextField
                label="Email"
                className="textfield"
                type="email"
                style={{ width: "100%" }}
                error={!!emailError}
                helperText={emailError}
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                autoComplete="off"
                size="small"
              />
            </div>

            <div className="margin_top">
              <TextField
                style={{ width: "100%" }}
                type={visible ? "text" : "password"}
                label="Password"
                error={!!passwordError}
                helperText={passwordError}
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                autoComplete="off"
                size="small"
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      onClick={handleClickShowPassword}
                      className="cursor-pointer"
                      style={{ cursor: "pointer" }}
                    >
                      {visible ? <VisibilityOff /> : <Visibility />}
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            {error && <p className="error-message">{error}</p>}


            <div className="margin_top">
              <Button
                type="primary"
                onClick={handleLogin}
                className="log_btn"
                loading={loading}
              >
                PROCEED
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
